export default __webpack_public_path__ + "static/media/bestAtt.56121935.svg";